import { ComboInput } from "../combo-input";

interface Props {
  value: string[];
  onChange: (newValue: string[]) => void;
}

export function CompanyNameFilter({ value, onChange }: Props) {
  return (
    <ComboInput
      placeholder="Company Name (press enter to add)"
      value={value}
      onChange={onChange}
      isActive={value.length > 0}
      inputContainerProps={{ minW: 64 }}
      inputProps={{ w: 64 }}
    />
  );
}
